import React, { useState, useEffect, useRef } from "react";

const EventSearch = ({ filter, activeSearch, updateFilters }) => {
    let t = useRef(null);
    const initialRender = useRef(true);

    const [searchValue, setSearchValue] = useState("");

    useEffect(() => {
        if (initialRender.current === false) {
            clearTimeout(t.current);

            t.current = setTimeout(() => {
                if (searchValue.length >= 2) {
                    updateFilters("zoekterm", searchValue);
                }

                if (searchValue.length === 0) {
                    updateFilters("zoekterm", "");
                }
            }, 250);
        }

        initialRender.current = false;
    }, [t, initialRender, searchValue]);

    useEffect(() => {
        if (typeof activeSearch !== "undefined") {
            setSearchValue(activeSearch);
        } else {
            setSearchValue("");
        }
    }, [activeSearch]);

    useEffect(() => {
        const onKeyDown = (event) => {
            const { keyCode } = event;

            switch (keyCode) {
                case 13:
                    event.preventDefault();
                    break;
                default:
            }
        };

        window.addEventListener('keydown', onKeyDown);

        return () => {
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [searchValue]);

    return (
        <input
            id={filter.key}
            name={filter.key}
            placeholder={filter.title}
            className={`event-overview__field is-search${searchValue !== "" ? " is-active" : ""}`}
            value={searchValue}
            onChange={(event) => setSearchValue(event.currentTarget.value)}
            type="search"
        />
    );
};

export default EventSearch;
